// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qk-6";
export var imgContainer = "_qk-3";
export var menuIcon = "_qk-5";
export var pillWrapper = "_qk-2";
export var pillsContainer = "_qk-1";
export var subscriptionCard = "_qk-0";
export var subscriptionLogo = "_qk-4";